import React from "react";
import styles from "./bid-details-skeleton.module.scss";
import SkeletonC from "../../../stories/common/skeleton";

const BidDetailsSkeleton = () => {
  return (
    <div className={styles.bidDetails} tabIndex={15}>
      <SkeletonC width="50%" height="30px"  className={styles.title}
      // className="mb-5"
       />

      <div className={styles.bidWrap}>
        <SkeletonC width="50%" height="60px" className={styles.bidBox} />
        <SkeletonC width="50%" height="60px" className={styles.bidBox} />
      </div>

      <div className={styles.bidWrap}>
        <SkeletonC width="50%" height="60px" className={styles.bidBox} />
        <SkeletonC width="50%" height="60px" className={styles.bidBox} />
      </div>

      <div className={styles.bidWrap}>
        <SkeletonC width="50%" height="60px" className={styles.bidBox} />
        <SkeletonC width="50%" height="60px" className={styles.bidBox} />
      </div>
    </div>
  );
};

export default BidDetailsSkeleton;
